export const VISIT_STATUS = {
  draft: "Draft",
  pending_approval: "Pending",
  approved: "Approved",
  rejected: "Rejected",
  invited: "Invited",
  expected: "Expected",
  arrived: "Arrived",
  checked_in: "On site",
  checked_out: "Checked out",
  expired: "Expired",
  cancelled: "Cancelled",
  denied: "Denied",
};

export const STATUS_TONE = {
  pending_approval: "bg-amber-50 text-amber-900 border-amber-200",
  approved: "bg-sky-50 text-sky-900 border-sky-200",
  invited: "bg-sky-50 text-sky-900 border-sky-200",
  expected: "bg-sky-50 text-sky-900 border-sky-200",
  arrived: "bg-orange-50 text-orange-900 border-orange-200",
  checked_in: "bg-emerald-50 text-emerald-900 border-emerald-200",
  checked_out: "bg-slate-100 text-slate-700 border-slate-200",
  rejected: "bg-rose-50 text-rose-900 border-rose-200",
  denied: "bg-rose-50 text-rose-900 border-rose-200",
  cancelled: "bg-slate-100 text-slate-700 border-slate-200",
  expired: "bg-slate-100 text-slate-700 border-slate-200",
  draft: "bg-slate-100 text-slate-700 border-slate-200",
};
